__turbopack_context__.v({
  "allLink": "direction-content-module__TSoJmq__allLink",
  "allLinkIcon": "direction-content-module__TSoJmq__allLinkIcon",
  "arrow": "direction-content-module__TSoJmq__arrow",
  "content": "direction-content-module__TSoJmq__content",
  "frameArtwork": "direction-content-module__TSoJmq__frameArtwork",
  "frameEnter": "direction-content-module__TSoJmq__frameEnter",
  "frameIllumination": "direction-content-module__TSoJmq__frameIllumination",
  "frameLayer": "direction-content-module__TSoJmq__frameLayer",
  "frameLeave": "direction-content-module__TSoJmq__frameLeave",
  "frameLitImage": "direction-content-module__TSoJmq__frameLitImage",
  "framePhoto": "direction-content-module__TSoJmq__framePhoto",
  "heading": "direction-content-module__TSoJmq__heading",
  "newsCopy": "direction-content-module__TSoJmq__newsCopy",
  "newsCover": "direction-content-module__TSoJmq__newsCover",
  "newsFrame": "direction-content-module__TSoJmq__newsFrame",
  "newsLink": "direction-content-module__TSoJmq__newsLink",
  "newsList": "direction-content-module__TSoJmq__newsList",
  "newsTitle": "direction-content-module__TSoJmq__newsTitle",
  "newsWall": "direction-content-module__TSoJmq__newsWall",
  "notice": "direction-content-module__TSoJmq__notice",
  "projectCopy": "direction-content-module__TSoJmq__projectCopy",
  "projectCountLabel": "direction-content-module__TSoJmq__projectCountLabel",
  "projectGlass": "direction-content-module__TSoJmq__projectGlass",
  "projectGlassBase": "direction-content-module__TSoJmq__projectGlassBase",
  "projectGlassLit": "direction-content-module__TSoJmq__projectGlassLit",
  "projectGlassTheme": "direction-content-module__TSoJmq__projectGlassTheme",
  "projectLink": "direction-content-module__TSoJmq__projectLink",
  "projectMeta": "direction-content-module__TSoJmq__projectMeta",
  "projectMetaIcon": "direction-content-module__TSoJmq__projectMetaIcon",
  "projectNumber": "direction-content-module__TSoJmq__projectNumber",
  "projectTitle": "direction-content-module__TSoJmq__projectTitle",
  "projects": "direction-content-module__TSoJmq__projects",
  "projectsObject": "direction-content-module__TSoJmq__projectsObject",
  "projectsPanel": "direction-content-module__TSoJmq__projectsPanel",
  "projectsScroll": "direction-content-module__TSoJmq__projectsScroll",
  "projectsSurface": "direction-content-module__TSoJmq__projectsSurface",
  "srOnly": "direction-content-module__TSoJmq__srOnly",
  "wallArchive": "direction-content-module__TSoJmq__wallArchive",
  "wallLamp": "direction-content-module__TSoJmq__wallLamp",
  "wallLighting": "direction-content-module__TSoJmq__wallLighting",
});
